export default {
  'STATUSSELECT' (state) {
    return state.statusSelect
  },
  'STATUSLIST' (state) {
    return state.statusList
  },
  'REFSTATUSLIST' (state) {
    return state.refstatusList
  },
  'ATTACHMENTTYPE' (state) {
    return state.attachmentType
  },
  isCheckOutEnabled (state) {
    return state.setting.has_checkout
  }
}
